import React from 'react'
import { withRouter } from 'react-router-dom';
import { Message, Dimmer, Loader, Button, Grid, Divider, Segment } from 'semantic-ui-react';
import OutpatientNavigationView from "../../../component/sysadmin/outpatient/outpatient_navigation_view";
import OutpatientView from "../../../component/sysadmin/outpatient/outpatient_view";
import OutpatientViewImbursement from "../../../component/sysadmin/outpatient/outpatient_view_imbursement";
import OutpatientViewSystemData from "../../../component/sysadmin/outpatient/outpatient_view_system_data";
import { Route, Switch } from 'react-router-dom';

class OutpatientViewPage extends React.Component {

    render() {

        return (
            <Grid>
                <Grid.Column width={4}>
                    <OutpatientNavigationView />
                </Grid.Column>

                <Grid.Column width={12}>
                    <Switch>
                        <Route path="/systemadmin/useroutpatient/view/imbursement" component={() => <OutpatientViewImbursement />} />
                        <Route path="/systemadmin/useroutpatient/view/systemdata" component={() => <OutpatientViewSystemData />} />
                        <Route path="/systemadmin/useroutpatient/view" component={() => <OutpatientView />} />
                    </Switch>
                </Grid.Column>

            </Grid>
        )
    }

}

export default withRouter(OutpatientViewPage);